export const tabs = () => {
    const $ = jQuery;

    const tabs_triggers = $('.tabs-triggers .tab-trigger');
    
    const handleTabTriggers = (e) => {
        const trigger = $(e.currentTarget);

        if (! trigger.hasClass('active')) {
            const tabSlug = trigger.data('tab');
            const activeTrigger = trigger.siblings('.active');

            const activeTab = trigger.parents('.tabs-wrapper').find('.tabs').children('.active');
            const newTab = trigger.parents('.tabs-wrapper').find('.tabs').children('[data-tab="' + tabSlug + '"]');

            activeTrigger.removeClass('active');
            activeTab.removeClass('active');

            trigger.addClass('active');
            newTab.addClass('active');
        }
    }

    tabs_triggers.on('click', handleTabTriggers);
};